
import Copy from "@/components/Copy";
import ReturnCom from "@/components/ReturnCom";
import { BRIDGE_LINK } from "@/collocate";
import { useTranslation } from "react-i18next";
import ButtonPrimary from "@/components/ButtonPrimary";

const Bridge = () => {
    const { t } = useTranslation();

    const handleVisitBridge = () => {
        window.location.href = BRIDGE_LINK;
    };


    return (
        <div className="mx-4 mt-3.5 md:max-w-[750px] md:mx-auto md:mt-6">
            <div>
                <ReturnCom title={t('bridge.title')} />
            </div>

            {/* 描述文字 */}
            <div className="mt-5.5 md:mt-8 text-white text-13px md:text-sm leading-relaxed bg-3a rounded-lg p-4 md:p-5">
                {t('bridge.description')}
            </div>

            {/* 桥接地址 */}
            <div className="text-white mt-5.5 md:mt-8">
                <div className="mb-2.5 text-13px md:text-sm md:mb-3">{t('bridge.bridgeLink')}</div>
                <div className="border rounded-md border-ad h-12 md:h-14 px-2.5 md:px-4 flex items-center justify-between">
                    <div className="text-xs md:text-sm text-white truncate pr-2 flex-1">
                        {BRIDGE_LINK}
                    </div>
                    <Copy className="w-4 md:w-5 flex-shrink-0" text={BRIDGE_LINK} />
                </div>
            </div>

            {/* 访问按钮 */}
            <div className="mt-6 md:mt-8">
                <ButtonPrimary
                    block
                    onClick={handleVisitBridge} text={
                        <div className="flex items-center">
                            <span>{t('bridge.visitBridge')}</span>
                            <svg
                                className="w-4 h-4 md:w-5 md:h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                />
                            </svg>
                        </div>
                    }
                />

            </div>

            {/* 提示信息 */}
            <div className="mt-4 md:mt-5 text-xs md:text-sm text-gray-400 text-center">
                {t('bridge.description')}
            </div>
        </div>
    );
}

export default Bridge
